// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3_NCF","content":"LoadingAlert_content__2X2BV"};